// ConditiiPage.jsx — FULL (layout curat + clase normale)
import React from "react";
import Header from "../components/Header";
import TermeniComponent from "../components/about/Termeni";
import ConditiiComponent from "../components/about/Conditii";
import Footer from "../components/Footer";
import "../styles/about/termenipage.css";

const ConditiiPage = () => {
  return (
    <div className="srTCPage">
      <Header />

      <main className="srTCPage__main">
        <section className="srTCPage__hero">
          <h1 className="srTCPage__title">Termeni și Condiții</h1>
          <p className="srTCPage__subtitle">
            Mai jos găsești definițiile de bază și regulile utilizării platformei.
          </p>
        </section>

        <section className="srTCPage__card">
          <h2 className="srTCPage__sectionTitle">Termeni</h2>

          <ul className="srTCPage__list">
            <li className="srTCPage__listItem">
              <span className="srTCPage__term">Locator</span>
              <span className="srTCPage__desc">— Cel care dă în chirie</span>
            </li>
            <li className="srTCPage__listItem">
              <span className="srTCPage__term">Locatar</span>
              <span className="srTCPage__desc">— Cel care închiriază</span>
            </li>
          </ul>
        </section>

        {/* componentele tale existente */}
        <section className="srTCPage__block">
          <TermeniComponent />
        </section>

        <section className="srTCPage__block">
          <ConditiiComponent />
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ConditiiPage;